module.exports = "pegasus_template/assets/themecapture1/simple/104.png";